import {DateUtils} from "@shared/utils/date.utils";

export class PageableParams {
  page: number = 0;
  size: number = 20;
  sort: string[] = [];
  filters: Record<string, unknown> = {};

  constructor(init?: Partial<PageableParams>) {
    if (init) Object.assign(this, init);
  }

  /**
   * Remove valores nulos, indefinidos ou vazios dos filtros.
   * Converte campos Date em string yyyy-MM-dd.
   */
  static cleanFilters(
    filters: Record<string, unknown>,
    dataTableColumns?: Array<{ field: string; format?: string }>
  ): Record<string, unknown> {
    return Object.fromEntries(
      Object.entries(filters)
        .filter(([, value]) => value !== null && value !== undefined && value !== "")
        .flatMap(([key, value]) => {
          // pega a definição da coluna
          const col = dataTableColumns?.find((c: { field: string; }) => c.field === key);

          // Campo "date": converte para yyyy-MM-dd
          if (col?.format === "date" && (value instanceof Date || PageableParams.isDateString(value))) {
            return [[key, DateUtils.toIsoDateOnly(value as Date | string)]];
          }

          // Campo "daterange": renomeia as keys
          if (col?.format === "daterange" && Array.isArray(value)) {
            const [start, end] = value as (Date | string | undefined)[];
            console.log(start, end);
            if (end === null) {
              return [[key, DateUtils.toIsoDateOnly(start)]];
            }
            return [
              [`${key}Inicio`, start ? DateUtils.toIsoDateOnly(start) : undefined],
              [`${key}Fim`, end ? DateUtils.toIsoDateOnly(end) : undefined]
            ];
          }

          // Campos normais
          return [[key, value]];
        })
    );
  }

  static areFiltersEmpty(filters: Record<string, unknown>): boolean {
    return Object.values(filters).every(
      (value) => value === null || value === undefined || value === ""
    );
  }

  /**
   * Checa se um valor string é uma data válida (ex: vindo de um p-datepicker).
   */
  private static isDateString(value: unknown): boolean {
    if (typeof value !== "string") return false;
    const d = new Date(value);
    return !isNaN(d.getTime());
  }

  /**
   * Converte os parâmetros para uma query string de URL.
   */
  toQueryString(): string {
    const params = new URLSearchParams();

    params.set("page", String(this.page));
    params.set("size", String(this.size));

    // Ordenação
    this.sort?.forEach(s => {
      if (s) params.append("sort", s);
    });

    // Filtros
    Object.entries(this.filters || {}).forEach(([key, value]) => {
      if (this.isValidFilterValue(value)) {
        if (Array.isArray(value)) {
          value.forEach(v => params.append(key, String(v)));
        } else {
          params.set(key, String(value));
        }
      }
    });

    return params.toString();
  }

  onlyFiltersToQueryString(): string {
    const params = new URLSearchParams();
    Object.entries(this.filters || {}).forEach(([key, value]) => {
      if (this.isValidFilterValue(value)) {
        if (Array.isArray(value)) {
          value.forEach(v => params.append(key, String(v)));
        } else {
          params.set(key, String(value));
        }
      }
    });
    return params.toString();
  }

  /**
   * Verifica se o valor é válido para ser enviado como filtro.
   */
  private isValidFilterValue(value: unknown): boolean {
    return value !== null && value !== undefined && value !== "";
  }
}
